export const defaultColumnOrder: string[] = ['name', 'progressPercentage', 'requestedTime', 'requestedBy', 'approvers']
